import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _path;
const _excluded = ["size", "title", "titleId"];
import * as React from 'react';
import PropTypes from 'prop-types';
import { sizes, sizeMap, useId } from './utils';
function Minus(_ref) {
  let {
      size: sizeProp,
      title,
      titleId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const size = sizeMap.get(sizeProp);
  titleId = useId(titleId);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size.width,
    height: size.height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#212429",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.583 13.889A.585.585 0 015 13.306v-2.723c0-.32.263-.583.583-.583h12.834c.32 0 .583.263.583.583v2.723c0 .32-.262.583-.583.583H5.583z"
  })));
}
Minus.sizes = sizes;
Minus.defaultProps = {
  size: sizes.md
};
Minus.propTypes = {
  size: PropTypes.oneOf([Minus.sizes.xs, Minus.sizes.sm, Minus.sizes.md, Minus.sizes.lg, Minus.sizes.xl]),
  titleId: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default Minus;